/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { KnowledgeLink } from '../models/KnowledgeLink';
import type { KnowledgeLinkBase } from '../models/KnowledgeLinkBase';
import type { KnowledgeLinkReorder } from '../models/KnowledgeLinkReorder';
import type { KnowledgeLinkUpdate } from '../models/KnowledgeLinkUpdate';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminKnowledgeLinksService {

    /**
     * Create Knowledge Link
     * @param requestBody
     * @returns KnowledgeLink Successful Response
     * @throws ApiError
     */
    public static createKnowledgeLinkApiV1AdminKnowledgeLinksPost(
        requestBody: KnowledgeLinkBase,
    ): CancelablePromise<KnowledgeLink> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/knowledge-links',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Reorder Knowledge Links
     * @param requestBody
     * @returns KnowledgeLink Successful Response
     * @throws ApiError
     */
    public static reorderKnowledgeLinksApiV1AdminKnowledgeLinksReorderPut(
        requestBody: Array<KnowledgeLinkReorder>,
    ): CancelablePromise<Array<KnowledgeLink>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/knowledge-links/reorder',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Knowledge Link
     * @param linkId
     * @param requestBody
     * @returns KnowledgeLink Successful Response
     * @throws ApiError
     */
    public static updateKnowledgeLinkApiV1AdminKnowledgeLinksLinkIdPut(
        linkId: number,
        requestBody: KnowledgeLinkUpdate,
    ): CancelablePromise<KnowledgeLink> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/knowledge-links/{link_id}',
            path: {
                'link_id': linkId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Knowledge Link
     * @param linkId
     * @returns void
     * @throws ApiError
     */
    public static deleteKnowledgeLinkApiV1AdminKnowledgeLinksLinkIdDelete(
        linkId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/knowledge-links/{link_id}',
            path: {
                'link_id': linkId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
